import styled from 'styled-components';

import { colors, cssBreakpoints, gutterWidth } from 'theme/theme';

export const MobileNotificationsDropdownHolder = styled.div`
  position: fixed;
  top: 0;
  left: 0;

  width: 100%;
  height: 100vh;
  overflow-y: scroll;
  background-color: ${colors.white};
  z-index: 104;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    display: none;
  }
`;

export const MobileNotificationsDropdownHeader = styled.div`
  align-items: center;
  background: ${colors.white};
  display: flex;
  justify-content: space-between;
  position: relative;
  padding: 0 ${gutterWidth / 2}px;
  height: 60px;
  width: 100%;
  border-bottom: 1px solid ${colors.selectionGrey};
`;
